module.exports = __webpack_public_path__ + "static/media/heldane-text-web-regular.7f9f4e80.woff";